// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none"
// @generated from file common/billing.proto (package common, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { CurrencyCode, CurrencyType, NetworkCode, PaymentProvider } from "./payment_pb";
import { file_common_payment } from "./payment_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file common/billing.proto.
 */
export const file_common_billing: GenFile = /*@__PURE__*/
  fileDesc("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", [file_common_payment]);

/**
 * @generated from message common.AccountMessage
 */
export type AccountMessage = Message<"common.AccountMessage"> & {
  /**
   * @generated from field: string real_balance = 1;
   */
  realBalance: string;

  /**
   * @generated from field: string demo_balance = 2;
   */
  demoBalance: string;

  /**
   * @generated from field: string bonus_balance = 3;
   */
  bonusBalance: string;

  /**
   * @generated from field: string real_bets_amount = 4;
   */
  realBetsAmount: string;

  /**
   * @generated from field: string demo_bets_amount = 5;
   */
  demoBetsAmount: string;

  /**
   * @generated from field: string bonus_bets_amount = 6;
   */
  bonusBetsAmount: string;

  /**
   * @generated from field: string hold_amount = 7;
   */
  holdAmount: string;

  /**
   * @generated from field: optional string hold_expires_at = 8;
   */
  holdExpiresAt?: string;

  /**
   * @generated from field: optional string hold_description = 9;
   */
  holdDescription?: string;

  /**
   * Partner-account fields. Populated only on admin endpoints; the
   * client `UserRPC.getBalance` mapper swaps partner_balance into
   * real_balance for is_partner viewers and leaves these blank.
   *
   * @generated from field: string partner_balance = 10;
   */
  partnerBalance: string;

  /**
   * @generated from field: string partner_bets_amount = 11;
   */
  partnerBetsAmount: string;

  /**
   * Combined tradable balance under Multi Balance Funding: real (or partner) + active bonus.
   * What the client shows as the user's single balance in the trading UI.
   *
   * @generated from field: string trading_balance = 12;
   */
  tradingBalance: string;
};

/**
 * Describes the message common.AccountMessage.
 * Use `create(AccountMessageSchema)` to create a new message.
 */
export const AccountMessageSchema: GenMessage<AccountMessage> = /*@__PURE__*/
  messageDesc(file_common_billing, 0);

/**
 * @generated from message common.OrderMessage
 */
export type OrderMessage = Message<"common.OrderMessage"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: common.OrderType type = 2;
   */
  type: OrderType;

  /**
   * @generated from field: common.CurrencyType currency_type = 3;
   */
  currencyType: CurrencyType;

  /**
   * @generated from field: string amount = 4;
   */
  amount: string;

  /**
   * @generated from field: common.CurrencyCode currency = 5;
   */
  currency: CurrencyCode;

  /**
   * @generated from field: common.PaymentProvider provider = 6;
   */
  provider: PaymentProvider;

  /**
   * @generated from field: optional string public_note = 7;
   */
  publicNote?: string;

  /**
   * @generated from field: optional string external_id = 8;
   */
  externalId?: string;

  /**
   * @generated from field: optional string payment_url = 9;
   */
  paymentUrl?: string;

  /**
   * @generated from field: common.OrderStatus status = 10;
   */
  status: OrderStatus;

  /**
   * @generated from field: optional string created_at = 11;
   */
  createdAt?: string;

  /**
   * @generated from field: optional string processed_at = 12;
   */
  processedAt?: string;

  /**
   * @generated from field: optional common.NetworkCode network = 13;
   */
  network?: NetworkCode;

  /**
   * @generated from field: optional string wallet_address = 14;
   */
  walletAddress?: string;

  /**
   * @generated from field: optional string tx_hash = 15;
   */
  txHash?: string;

  /**
   * @generated from field: optional string payment_method = 16;
   */
  paymentMethod?: string;

  /**
   * @generated from field: optional string fee = 17;
   */
  fee?: string;

  /**
   * @generated from field: optional string display_id = 18;
   */
  displayId?: string;

  /**
   * @generated from field: optional string comment = 19;
   */
  comment?: string;

  /**
   * @generated from field: optional common.FiatDetails fiat_details = 20;
   */
  fiatDetails?: FiatDetails;

  /**
   * @generated from field: optional string sent_amount = 21;
   */
  sentAmount?: string;

  /**
   * @generated from field: optional string sent_currency = 22;
   */
  sentCurrency?: string;

  /**
   * @generated from field: optional string credited_amount = 23;
   */
  creditedAmount?: string;

  /**
   * @generated from field: bool is_notification_read = 24;
   */
  isNotificationRead: boolean;

  /**
   * @generated from field: optional string pay_address = 25;
   */
  payAddress?: string;

  /**
   * @generated from field: optional string pay_amount = 26;
   */
  payAmount?: string;

  /**
   * @generated from field: optional string payin_extra_id = 27;
   */
  payinExtraId?: string;

  /**
   * @generated from field: optional string expires_at = 28;
   */
  expiresAt?: string;
};

/**
 * Describes the message common.OrderMessage.
 * Use `create(OrderMessageSchema)` to create a new message.
 */
export const OrderMessageSchema: GenMessage<OrderMessage> = /*@__PURE__*/
  messageDesc(file_common_billing, 1);

/**
 * @generated from message common.CryptoDetails
 */
export type CryptoDetails = Message<"common.CryptoDetails"> & {
  /**
   * @generated from field: optional common.NetworkCode network = 1;
   */
  network?: NetworkCode;

  /**
   * @generated from field: optional string destination = 2;
   */
  destination?: string;

  /**
   * @generated from field: optional string tx_hash = 3;
   */
  txHash?: string;

  /**
   * @generated from field: optional string sent_amount = 4;
   */
  sentAmount?: string;

  /**
   * @generated from field: optional string sent_currency = 5;
   */
  sentCurrency?: string;

  /**
   * @generated from field: optional string received_amount = 6;
   */
  receivedAmount?: string;

  /**
   * @generated from field: optional string received_currency = 7;
   */
  receivedCurrency?: string;

  /**
   * @generated from field: optional string explorer_url = 8;
   */
  explorerUrl?: string;

  /**
   * @generated from field: optional string network_name = 9;
   */
  networkName?: string;

  /**
   * @generated from field: optional string display_id = 10;
   */
  displayId?: string;

  /**
   * @generated from field: optional string recipient_address = 11;
   */
  recipientAddress?: string;
};

/**
 * Describes the message common.CryptoDetails.
 * Use `create(CryptoDetailsSchema)` to create a new message.
 */
export const CryptoDetailsSchema: GenMessage<CryptoDetails> = /*@__PURE__*/
  messageDesc(file_common_billing, 2);

/**
 * @generated from message common.FiatDetails
 */
export type FiatDetails = Message<"common.FiatDetails"> & {
  /**
   * @generated from field: optional string bank = 1;
   */
  bank?: string;

  /**
   * @generated from field: optional string full_name = 3;
   */
  fullName?: string;

  /**
   * @generated from field: optional string bank_name = 4;
   */
  bankName?: string;

  /**
   * @generated from field: optional string payment_method = 5;
   */
  paymentMethod?: string;

  /**
   * @generated from field: optional string recipient = 7;
   */
  recipient?: string;
};

/**
 * Describes the message common.FiatDetails.
 * Use `create(FiatDetailsSchema)` to create a new message.
 */
export const FiatDetailsSchema: GenMessage<FiatDetails> = /*@__PURE__*/
  messageDesc(file_common_billing, 3);

/**
 * @generated from message common.TransactionMessage
 */
export type TransactionMessage = Message<"common.TransactionMessage"> & {
  /**
   * @generated from field: optional string id = 1;
   */
  id?: string;

  /**
   * @generated from field: common.AccountType account_type = 2;
   */
  accountType: AccountType;

  /**
   * @generated from field: optional string job_id = 3;
   */
  jobId?: string;

  /**
   * @generated from field: common.TransactionKind kind = 4;
   */
  kind: TransactionKind;

  /**
   * @generated from field: common.TransactionRail rail = 5;
   */
  rail: TransactionRail;

  /**
   * @generated from field: common.BillingAction action = 6;
   */
  action: BillingAction;

  /**
   * @generated from field: common.TransactionOperation operation = 7;
   */
  operation: TransactionOperation;

  /**
   * @generated from field: optional string entity_id = 8;
   */
  entityId?: string;

  /**
   * @generated from field: optional common.BillingEntityType entity_type = 9;
   */
  entityType?: BillingEntityType;

  /**
   * @generated from field: optional string account_id = 10;
   */
  accountId?: string;

  /**
   * @generated from field: string amount = 11;
   */
  amount: string;

  /**
   * @generated from field: common.CurrencyCode currency = 12;
   */
  currency: CurrencyCode;

  /**
   * @generated from field: optional common.NetworkCode network = 13;
   */
  network?: NetworkCode;

  /**
   * @generated from field: optional string wallet_address = 14;
   */
  walletAddress?: string;

  /**
   * @generated from field: optional string tx_hash = 15;
   */
  txHash?: string;

  /**
   * @generated from field: optional string bank = 16;
   */
  bank?: string;

  /**
   * @generated from field: optional string card_number = 17;
   */
  cardNumber?: string;

  /**
   * @generated from field: optional string full_name = 18;
   */
  fullName?: string;

  /**
   * @generated from field: optional string processed_at = 19;
   */
  processedAt?: string;

  /**
   * @generated from field: optional string processor_id = 20;
   */
  processorId?: string;

  /**
   * @generated from field: optional string processor_email = 21;
   */
  processorEmail?: string;

  /**
   * @generated from field: optional string created_at = 22;
   */
  createdAt?: string;

  /**
   * @generated from field: optional common.CryptoDetails crypto_details = 23;
   */
  cryptoDetails?: CryptoDetails;

  /**
   * @generated from field: optional common.FiatDetails fiat_details = 24;
   */
  fiatDetails?: FiatDetails;

  /**
   * Ledger enrichment (populated in admin ledger view)
   *
   * @generated from field: optional common.BillingJobMessage billing_job = 25;
   */
  billingJob?: BillingJobMessage;

  /**
   * @generated from field: repeated common.BillingEventMessage billing_events = 26;
   */
  billingEvents: BillingEventMessage[];
};

/**
 * Describes the message common.TransactionMessage.
 * Use `create(TransactionMessageSchema)` to create a new message.
 */
export const TransactionMessageSchema: GenMessage<TransactionMessage> = /*@__PURE__*/
  messageDesc(file_common_billing, 4);

/**
 * @generated from message common.BillingJobMessage
 */
export type BillingJobMessage = Message<"common.BillingJobMessage"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string job_id = 2;
   */
  jobId: string;

  /**
   * @generated from field: common.BillingAction job_type = 3;
   */
  jobType: BillingAction;

  /**
   * @generated from field: string entity_id = 4;
   */
  entityId: string;

  /**
   * @generated from field: common.BillingEntityType entity_type = 5;
   */
  entityType: BillingEntityType;

  /**
   * @generated from field: optional string executed_at = 6;
   */
  executedAt?: string;

  /**
   * @generated from field: optional bool success = 7;
   */
  success?: boolean;

  /**
   * @generated from field: optional string error_message = 8;
   */
  errorMessage?: string;

  /**
   * @generated from field: optional string created_at = 9;
   */
  createdAt?: string;
};

/**
 * Describes the message common.BillingJobMessage.
 * Use `create(BillingJobMessageSchema)` to create a new message.
 */
export const BillingJobMessageSchema: GenMessage<BillingJobMessage> = /*@__PURE__*/
  messageDesc(file_common_billing, 5);

/**
 * @generated from message common.BillingEventMessage
 */
export type BillingEventMessage = Message<"common.BillingEventMessage"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string entity_id = 2;
   */
  entityId: string;

  /**
   * @generated from field: common.BillingEntityType entity_type = 3;
   */
  entityType: BillingEntityType;

  /**
   * @generated from field: common.BillingEventType event_type = 4;
   */
  eventType: BillingEventType;

  /**
   * @generated from field: optional int32 from_state = 5;
   */
  fromState?: number;

  /**
   * @generated from field: optional int32 to_state = 6;
   */
  toState?: number;

  /**
   * @generated from field: optional string job_id = 7;
   */
  jobId?: string;

  /**
   * @generated from field: optional string reason = 8;
   */
  reason?: string;

  /**
   * @generated from field: optional string created_at = 9;
   */
  createdAt?: string;

  /**
   * @generated from field: optional string payload_json = 10;
   */
  payloadJson?: string;
};

/**
 * Describes the message common.BillingEventMessage.
 * Use `create(BillingEventMessageSchema)` to create a new message.
 */
export const BillingEventMessageSchema: GenMessage<BillingEventMessage> = /*@__PURE__*/
  messageDesc(file_common_billing, 6);

/**
 * @generated from message common.AdminOrderMessage
 */
export type AdminOrderMessage = Message<"common.AdminOrderMessage"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: common.OrderType type = 2;
   */
  type: OrderType;

  /**
   * @generated from field: common.CurrencyType currency_type = 3;
   */
  currencyType: CurrencyType;

  /**
   * @generated from field: string amount = 4;
   */
  amount: string;

  /**
   * @generated from field: common.CurrencyCode currency = 5;
   */
  currency: CurrencyCode;

  /**
   * @generated from field: common.OrderStatus status = 6;
   */
  status: OrderStatus;

  /**
   * @generated from field: common.PaymentProvider provider = 7;
   */
  provider: PaymentProvider;

  /**
   * @generated from field: optional string external_id = 8;
   */
  externalId?: string;

  /**
   * @generated from field: optional string payment_url = 9;
   */
  paymentUrl?: string;

  /**
   * @generated from field: optional string created_at = 10;
   */
  createdAt?: string;

  /**
   * @generated from field: optional string processed_at = 11;
   */
  processedAt?: string;

  /**
   * @generated from field: optional string user_id = 12;
   */
  userId?: string;

  /**
   * @generated from field: optional string user_email = 13;
   */
  userEmail?: string;

  /**
   * @generated from field: optional string user_full_name = 14;
   */
  userFullName?: string;

  /**
   * @generated from field: optional string public_note = 15;
   */
  publicNote?: string;

  /**
   * @generated from field: optional string private_note = 16;
   */
  privateNote?: string;

  /**
   * @generated from field: optional common.CryptoDetails crypto_details = 17;
   */
  cryptoDetails?: CryptoDetails;

  /**
   * @generated from field: optional common.FiatDetails fiat_details = 18;
   */
  fiatDetails?: FiatDetails;

  /**
   * @generated from field: optional string provider_raw_json = 19;
   */
  providerRawJson?: string;

  /**
   * @generated from field: optional common.NetworkCode network = 20;
   */
  network?: NetworkCode;

  /**
   * @generated from field: optional string wallet_address = 21;
   */
  walletAddress?: string;

  /**
   * @generated from field: optional bool is_fully_paid = 22;
   */
  isFullyPaid?: boolean;

  /**
   * @generated from field: optional string credited_amount = 23;
   */
  creditedAmount?: string;

  /**
   * @generated from field: optional string fee = 24;
   */
  fee?: string;

  /**
   * @generated from field: optional string display_id = 25;
   */
  displayId?: string;

  /**
   * @generated from field: optional string comment = 26;
   */
  comment?: string;

  /**
   * @generated from field: optional bool is_partner = 27;
   */
  isPartner?: boolean;
};

/**
 * Describes the message common.AdminOrderMessage.
 * Use `create(AdminOrderMessageSchema)` to create a new message.
 */
export const AdminOrderMessageSchema: GenMessage<AdminOrderMessage> = /*@__PURE__*/
  messageDesc(file_common_billing, 7);

/**
 * @generated from enum common.AccountType
 */
export enum AccountType {
  /**
   * @generated from enum value: ACCOUNT_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: ACCOUNT_TYPE_DEMO = 1;
   */
  DEMO = 1,

  /**
   * @generated from enum value: ACCOUNT_TYPE_REAL = 2;
   */
  REAL = 2,

  /**
   * @generated from enum value: ACCOUNT_TYPE_BONUS = 3;
   */
  BONUS = 3,

  /**
   * Partner-account balance. Non-zero only for is_partner users. Bets
   * placed by an is_partner user with accountType=REAL are re-tagged
   * PARTNER at createBet time so they hit partnerBalance instead; client-
   * facing mappers swap PARTNER→REAL in responses to keep the partner's
   * app view identical to a regular client's. Admin endpoints see PARTNER
   * as-is. Deposits / withdrawals never write PARTNER directly — the
   * balance is fed only via admin balance corrections.
   *
   * @generated from enum value: ACCOUNT_TYPE_PARTNER = 4;
   */
  PARTNER = 4,
}

/**
 * Describes the enum common.AccountType.
 */
export const AccountTypeSchema: GenEnum<AccountType> = /*@__PURE__*/
  enumDesc(file_common_billing, 0);

/**
 * @generated from enum common.AdjustmentType
 */
export enum AdjustmentType {
  /**
   * @generated from enum value: ADJUSTMENT_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: ADJUSTMENT_TYPE_MANUAL_CORRECTION = 1;
   */
  MANUAL_CORRECTION = 1,

  /**
   * @generated from enum value: ADJUSTMENT_TYPE_BONUS_APPLY = 2;
   */
  BONUS_APPLY = 2,

  /**
   * @generated from enum value: ADJUSTMENT_TYPE_PROMO_APPLY = 3;
   */
  PROMO_APPLY = 3,
}

/**
 * Describes the enum common.AdjustmentType.
 */
export const AdjustmentTypeSchema: GenEnum<AdjustmentType> = /*@__PURE__*/
  enumDesc(file_common_billing, 1);

/**
 * @generated from enum common.AdjustmentStatus
 */
export enum AdjustmentStatus {
  /**
   * @generated from enum value: ADJUSTMENT_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: ADJUSTMENT_STATUS_CREATED = 1;
   */
  CREATED = 1,

  /**
   * @generated from enum value: ADJUSTMENT_STATUS_COMPLETED = 2;
   */
  COMPLETED = 2,
}

/**
 * Describes the enum common.AdjustmentStatus.
 */
export const AdjustmentStatusSchema: GenEnum<AdjustmentStatus> = /*@__PURE__*/
  enumDesc(file_common_billing, 2);

/**
 * @generated from enum common.BillingAction
 */
export enum BillingAction {
  /**
   * @generated from enum value: BILLING_ACTION_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: BILLING_ACTION_BET_ACCEPTANCE = 1;
   */
  BET_ACCEPTANCE = 1,

  /**
   * @generated from enum value: BILLING_ACTION_BET_SETTLEMENT = 2;
   */
  BET_SETTLEMENT = 2,

  /**
   * @generated from enum value: BILLING_ACTION_BET_SCHEDULING = 3;
   */
  BET_SCHEDULING = 3,

  /**
   * @generated from enum value: BILLING_ACTION_DEPOSIT_APPLY = 4;
   */
  DEPOSIT_APPLY = 4,

  /**
   * @generated from enum value: BILLING_ACTION_WITHDRAW_RESERVE = 5;
   */
  WITHDRAW_RESERVE = 5,

  /**
   * @generated from enum value: BILLING_ACTION_WITHDRAW_EXECUTE = 6;
   */
  WITHDRAW_EXECUTE = 6,

  /**
   * @generated from enum value: BILLING_ACTION_MANUAL_CORRECTION = 7;
   */
  MANUAL_CORRECTION = 7,

  /**
   * @generated from enum value: BILLING_ACTION_BONUS_APPLY = 8;
   */
  BONUS_APPLY = 8,

  /**
   * @generated from enum value: BILLING_ACTION_PROMO_APPLY = 9;
   */
  PROMO_APPLY = 9,

  /**
   * @generated from enum value: BILLING_ACTION_BONUS_CREDIT = 10;
   */
  BONUS_CREDIT = 10,

  /**
   * @generated from enum value: BILLING_ACTION_BONUS_DEBIT = 11;
   */
  BONUS_DEBIT = 11,

  /**
   * @generated from enum value: BILLING_ACTION_BONUS_TRANSFER = 12;
   */
  BONUS_TRANSFER = 12,

  /**
   * @generated from enum value: BILLING_ACTION_BET_CANCELLATION = 13;
   */
  BET_CANCELLATION = 13,

  /**
   * @generated from enum value: BILLING_ACTION_WITHDRAW_REJECT = 14;
   */
  WITHDRAW_REJECT = 14,
}

/**
 * Describes the enum common.BillingAction.
 */
export const BillingActionSchema: GenEnum<BillingAction> = /*@__PURE__*/
  enumDesc(file_common_billing, 3);

/**
 * @generated from enum common.BillingEventType
 */
export enum BillingEventType {
  /**
   * @generated from enum value: BILLING_EVENT_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: BILLING_EVENT_TYPE_CREATED = 1;
   */
  CREATED = 1,

  /**
   * @generated from enum value: BILLING_EVENT_TYPE_FAILED = 2;
   */
  FAILED = 2,

  /**
   * @generated from enum value: BILLING_EVENT_TYPE_STATE_CHANGED = 3;
   */
  STATE_CHANGED = 3,
}

/**
 * Describes the enum common.BillingEventType.
 */
export const BillingEventTypeSchema: GenEnum<BillingEventType> = /*@__PURE__*/
  enumDesc(file_common_billing, 4);

/**
 * @generated from enum common.BillingFailureReason
 */
export enum BillingFailureReason {
  /**
   * @generated from enum value: BILLING_FAILURE_REASON_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: BILLING_FAILURE_REASON_BILLING_NOT_FOUND = 1;
   */
  BILLING_NOT_FOUND = 1,

  /**
   * @generated from enum value: BILLING_FAILURE_REASON_DUPLICATE_JOB = 2;
   */
  DUPLICATE_JOB = 2,

  /**
   * @generated from enum value: BILLING_FAILURE_REASON_ENTITY_NOT_FOUND = 3;
   */
  ENTITY_NOT_FOUND = 3,

  /**
   * @generated from enum value: BILLING_FAILURE_REASON_INTERNAL_ERROR = 4;
   */
  INTERNAL_ERROR = 4,

  /**
   * @generated from enum value: BILLING_FAILURE_REASON_SCHEDULING_FAILED = 5;
   */
  SCHEDULING_FAILED = 5,

  /**
   * @generated from enum value: BILLING_FAILURE_REASON_INSUFFICIENT_FUNDS = 6;
   */
  INSUFFICIENT_FUNDS = 6,

  /**
   * @generated from enum value: BILLING_FAILURE_REASON_PRICE_NOT_FOUND = 7;
   */
  PRICE_NOT_FOUND = 7,

  /**
   * @generated from enum value: BILLING_FAILURE_REASON_CANCELLED_BY_ADMIN = 8;
   */
  CANCELLED_BY_ADMIN = 8,

  /**
   * @generated from enum value: BILLING_FAILURE_REASON_VALIDATION_ERROR = 9;
   */
  VALIDATION_ERROR = 9,

  /**
   * @generated from enum value: BILLING_FAILURE_REASON_ACCEPTANCE_FAILED = 10;
   */
  ACCEPTANCE_FAILED = 10,

  /**
   * @generated from enum value: BILLING_FAILURE_REASON_CANCELLED_BY_PARTNER = 11;
   */
  CANCELLED_BY_PARTNER = 11,
}

/**
 * Describes the enum common.BillingFailureReason.
 */
export const BillingFailureReasonSchema: GenEnum<BillingFailureReason> = /*@__PURE__*/
  enumDesc(file_common_billing, 5);

/**
 * @generated from enum common.BillingEntityType
 */
export enum BillingEntityType {
  /**
   * @generated from enum value: BILLING_ENTITY_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: BILLING_ENTITY_TYPE_ORDER = 1;
   */
  ORDER = 1,

  /**
   * @generated from enum value: BILLING_ENTITY_TYPE_BET = 2;
   */
  BET = 2,

  /**
   * @generated from enum value: BILLING_ENTITY_TYPE_ACCOUNT = 3;
   */
  ACCOUNT = 3,

  /**
   * @generated from enum value: BILLING_ENTITY_TYPE_ADJUSTMENT = 4;
   */
  ADJUSTMENT = 4,

  /**
   * @generated from enum value: BILLING_ENTITY_TYPE_BONUS = 5;
   */
  BONUS = 5,
}

/**
 * Describes the enum common.BillingEntityType.
 */
export const BillingEntityTypeSchema: GenEnum<BillingEntityType> = /*@__PURE__*/
  enumDesc(file_common_billing, 6);

/**
 * @generated from enum common.OrderType
 */
export enum OrderType {
  /**
   * @generated from enum value: ORDER_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: ORDER_TYPE_DEPOSIT = 1;
   */
  DEPOSIT = 1,

  /**
   * @generated from enum value: ORDER_TYPE_WITHDRAWAL = 2;
   */
  WITHDRAWAL = 2,
}

/**
 * Describes the enum common.OrderType.
 */
export const OrderTypeSchema: GenEnum<OrderType> = /*@__PURE__*/
  enumDesc(file_common_billing, 7);

/**
 * @generated from enum common.OrderStatus
 */
export enum OrderStatus {
  /**
   * @generated from enum value: ORDER_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: ORDER_STATUS_CREATED = 1;
   */
  CREATED = 1,

  /**
   * @generated from enum value: ORDER_STATUS_PROCESSING = 2;
   */
  PROCESSING = 2,

  /**
   * @generated from enum value: ORDER_STATUS_COMPLETED = 3;
   */
  COMPLETED = 3,

  /**
   * @generated from enum value: ORDER_STATUS_FAILED = 4;
   */
  FAILED = 4,

  /**
   * @generated from enum value: ORDER_STATUS_CANCELED = 5;
   */
  CANCELED = 5,

  /**
   * @generated from enum value: ORDER_STATUS_EXPIRED = 6;
   */
  EXPIRED = 6,

  /**
   * @generated from enum value: ORDER_STATUS_CANCELLED_BY_USER = 7;
   */
  CANCELLED_BY_USER = 7,
}

/**
 * Describes the enum common.OrderStatus.
 */
export const OrderStatusSchema: GenEnum<OrderStatus> = /*@__PURE__*/
  enumDesc(file_common_billing, 8);

/**
 * @generated from enum common.TransactionType
 */
export enum TransactionType {
  /**
   * @generated from enum value: TRANSACTION_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: TRANSACTION_TYPE_DEPOSIT = 1;
   */
  DEPOSIT = 1,

  /**
   * @generated from enum value: TRANSACTION_TYPE_WITHDRAWAL = 2;
   */
  WITHDRAWAL = 2,
}

/**
 * Describes the enum common.TransactionType.
 */
export const TransactionTypeSchema: GenEnum<TransactionType> = /*@__PURE__*/
  enumDesc(file_common_billing, 9);

/**
 * @generated from enum common.TransactionKind
 */
export enum TransactionKind {
  /**
   * @generated from enum value: TRANSACTION_KIND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: TRANSACTION_KIND_INTERNAL = 1;
   */
  INTERNAL = 1,

  /**
   * @generated from enum value: TRANSACTION_KIND_EXTERNAL = 2;
   */
  EXTERNAL = 2,
}

/**
 * Describes the enum common.TransactionKind.
 */
export const TransactionKindSchema: GenEnum<TransactionKind> = /*@__PURE__*/
  enumDesc(file_common_billing, 10);

/**
 * @generated from enum common.TransactionRail
 */
export enum TransactionRail {
  /**
   * @generated from enum value: TRANSACTION_RAIL_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: TRANSACTION_RAIL_INTERNAL = 1;
   */
  INTERNAL = 1,

  /**
   * @generated from enum value: TRANSACTION_RAIL_FIAT = 2;
   */
  FIAT = 2,

  /**
   * @generated from enum value: TRANSACTION_RAIL_CRYPTO = 3;
   */
  CRYPTO = 3,
}

/**
 * Describes the enum common.TransactionRail.
 */
export const TransactionRailSchema: GenEnum<TransactionRail> = /*@__PURE__*/
  enumDesc(file_common_billing, 11);

/**
 * @generated from enum common.TransactionOperation
 */
export enum TransactionOperation {
  /**
   * @generated from enum value: TRANSACTION_OPERATION_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: TRANSACTION_OPERATION_CREDIT = 1;
   */
  CREDIT = 1,

  /**
   * @generated from enum value: TRANSACTION_OPERATION_DEBIT = 2;
   */
  DEBIT = 2,

  /**
   * @generated from enum value: TRANSACTION_OPERATION_HOLD = 3;
   */
  HOLD = 3,

  /**
   * @generated from enum value: TRANSACTION_OPERATION_RELEASE = 4;
   */
  RELEASE = 4,

  /**
   * @generated from enum value: TRANSACTION_OPERATION_CONSUME = 5;
   */
  CONSUME = 5,
}

/**
 * Describes the enum common.TransactionOperation.
 */
export const TransactionOperationSchema: GenEnum<TransactionOperation> = /*@__PURE__*/
  enumDesc(file_common_billing, 12);

